import src from "IMAGE";
export default { src, width: 28, height: 28, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAR0lEQVR42oXPQQoAEBCF4bFxANfgAG5B1nY4iJs5mqdIafDqW/lLQ7QnJnYSPJjbY4QKigsSNCgQDnYE+Rd8v1iRA02PsWd2ujUJAvi5yF0AAAAASUVORK5CYII="};
